import { defineStore } from 'pinia'
import { ref, Ref } from 'vue'
import { interpret } from 'xstate-v4'
import { getAppMenuStateMachine } from '../apps/app-menu/machine'

export const useAppMenuStore = defineStore('appMenu', () => {
  const machine = getAppMenuStateMachine()
  const states: Ref<string[]> = ref([])
  const service = interpret(machine)
    .start()
    .onTransition((state) => {
      states.value = state.toStrings()
    })

  function toggleAccountMenu() {
    states?.value.includes('accountMenuVisible')
      ? service.send('HIDE_MENU')
      : service.send('SHOW_ACCOUNT_MENU')
  }

  function toggleAppMenu() {
    states?.value.includes('appMenuVisible')
      ? service.send('HIDE_MENU')
      : service.send('SHOW_APP_MENU')
  }

  function hideMenu() {
    service.send('HIDE_MENU')
  }

  function showAccountMenu() {
    service.send('SHOW_ACCOUNT_MENU')
  }

  const appMenuVisible = computed(() => states.value.includes('appMenuVisible'))
  const accountMenuVisible = computed(() =>
    states.value.includes('accountMenuVisible'),
  )

  const menuVisible = computed(
    () => appMenuVisible.value || accountMenuVisible.value,
  )
  return {
    send: service.send,
    states,
    toggleAppMenu,
    toggleAccountMenu,
    hideMenu,
    accountMenuVisible,
    appMenuVisible,
    menuVisible,
    showAccountMenu,
  }
})
